// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"wrapper___gj1n4","mobile":"mobile___FVGV2","iconWrapper":"iconWrapper___uIA8v","label":"label___i40KV","imgWrapper":"imgWrapper___w8Ez8"};